import React, { useState,useEffect } from 'react';
import { Outlet, NavLink, useNavigate,useLocation } from 'react-router-dom';
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  useTheme,
  useMediaQuery,
  Button,
  Avatar,
  Menu,
  MenuItem,
  Chip,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Fab
} from '@mui/material';
import {
  Home,
  People,
  Business,
  Event,
  CheckBox,
  Logout,
  Add,
  Menu as MenuIcon,
  Close,
  AccountCircle,
  Dashboard,
  MoreVert
} from '@mui/icons-material';
import { logout, getUserInfo } from '../../service/Auth/Auth.js';
import { getCurrentConfig } from '../../config/config.js';

const drawerWidth = 280;

const Layout = () => {
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);
  const [quickActionMenuAnchor, setQuickActionMenuAnchor] = useState(null);
  const [bottomNavValue, setBottomNavValue] = useState(0);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const config = getCurrentConfig();
  const userInfo = getUserInfo();
  const location = useLocation();

  const navItems = [
    { to: '/dashboard', icon: Dashboard, label: 'Dashboard' },
    { to: '/contacts', icon: People, label: 'Contacts' },
    { to: '/listings', icon: Business, label: 'Listings' },
    { to: '/ofi', icon: Event, label: 'OFI' },
    { to: '/actions', icon: CheckBox, label: 'Actions' }
  ];
    const navItemsBottom = [
    { to: '/dashboard', icon: Dashboard, label: 'Dashboard' },
    { to: '/contacts', icon: People, label: 'Contacts' },
    { to: '/listings', icon: Business, label: 'Listings' },
    { to: '/ofi', icon: Event, label: 'OFI' },
  ];

  const quickActions = [
    { to: '/contacts/add', label: 'Contact', icon: People },
    { to: '/listings/add', label: 'Listing', icon: Business },
    { to: '/ofi/add', label: 'OFI', icon: Event },
    { to: '/actions/add', label: 'Action', icon: CheckBox }
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
    setUserMenuAnchor(null);
    setMobileMenuAnchor(null);
  };

  const handleUserMenuOpen = (event) => {
    setUserMenuAnchor(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchor(null);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMenuAnchor(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuAnchor(null);
  };

  const handleQuickActionMenuOpen = (event) => {
    setQuickActionMenuAnchor(event.currentTarget);
  };

  const handleQuickActionMenuClose = () => {
    setQuickActionMenuAnchor(null);
  };

useEffect(() => {
  const currentIndex = navItemsBottom.findIndex(item =>
    location.pathname.startsWith(item.to)
  );

  // Adjust for FAB (inserted at index 2)
  if (currentIndex >= 0) {
    setBottomNavValue(currentIndex < 2 ? currentIndex : currentIndex + 1);
  }
}, [location.pathname]);

const handleBottomNavChange = (event, newValue) => {
  setBottomNavValue(newValue);

  // Ignore FAB (index 2)
  if (newValue === 2) return;

  const actualIndex = newValue > 2 ? newValue - 1 : newValue;

  if (navItemsBottom[actualIndex]) {
    navigate(navItemsBottom[actualIndex].to);
  }
};
  const SidebarContent = () => (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Sidebar Header */}
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: 1,
          borderColor: 'divider',
          minHeight: 64
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'bold',
            color: config.primaryColor || theme.palette.primary.main
          }}
        >
          {config.applicationName}
        </Typography>
      </Box>

      {/* Main Navigation */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <List sx={{ px: 1, py: 2 }}>
          {navItems.map(({ to, icon: Icon, label }) => (
            <ListItem key={to} disablePadding sx={{ mb: 0.5 }}>
              <ListItemButton
                component={NavLink}
                to={to}
                sx={{
                  borderRadius: 2,
                  '&.active': {
                    backgroundColor: config.primaryColor 
                      ? `${config.primaryColor}20` 
                      : theme.palette.primary.main + '20',
                    color: config.primaryColor || theme.palette.primary.main,
                    '& .MuiListItemIcon-root': {
                      color: config.primaryColor || theme.palette.primary.main
                    }
                  },
                  '&:hover': {
                    backgroundColor: theme.palette.action.hover
                  }
                }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <Icon />
                </ListItemIcon>
                <ListItemText primary={label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Divider sx={{ mx: 2 }} />

        {/* Quick Actions */}
        <Box sx={{ p: 2 }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 'bold',
              color: theme.palette.text.secondary,
              mb: 1,
              textTransform: 'uppercase',
              letterSpacing: 0.5
            }}
          >
            Quick Add
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {quickActions.map(({ to, label, icon: Icon }) => (
              <Button
                key={to}
                component={NavLink}
                to={to}
                variant="outlined"
                startIcon={<Add />}
                size="small"
                sx={{
                  justifyContent: 'flex-start',
                  textTransform: 'none',
                  borderColor: config.primaryColor || theme.palette.primary.main,
                  color: config.primaryColor || theme.palette.primary.main,
                  '&:hover': {
                    backgroundColor: config.primaryColor 
                      ? `${config.primaryColor}10` 
                      : theme.palette.primary.main + '10',
                    borderColor: config.primaryColor || theme.palette.primary.main
                  }
                }}
              >
                {label}
              </Button>
            ))}
          </Box>
        </Box>
      </Box>

      {/* User Info Footer */}
      <Box
        sx={{
          p: 2,
          borderTop: 1,
          borderColor: 'divider',
          backgroundColor: theme.palette.background.paper
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              backgroundColor: config.primaryColor || theme.palette.primary.main,
              fontSize: '0.875rem'
            }}
          >
            {userInfo.userFirstName?.charAt(0) || 'U'}
          </Avatar>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              {userInfo.userFirstName}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Online
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Desktop App Bar */}
      {!isMobile && (
        <AppBar
          position="fixed"
          sx={{
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            boxShadow: 1,
            borderBottom: 1,
            borderColor: 'divider'
          }}
        >
          <Toolbar>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
              <IconButton onClick={handleUserMenuOpen} size="large">
                <AccountCircle sx={{ fontSize: 40 }} />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
      )}

      {/* Mobile App Bar */}
      {isMobile && (
        <AppBar
          position="fixed"
          sx={{
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            boxShadow: 1,
            borderBottom: 1,
            borderColor: 'divider'
          }}
        >
          <Toolbar>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                flexGrow: 1,
                fontWeight: 'bold',
                color: config.primaryColor || theme.palette.primary.main
              }}
            >
              {config.name}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton onClick={handleMobileMenuOpen}>
                <MoreVert />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
      )}

      {/* Desktop User Menu */}
      <Menu
        anchorEl={userMenuAnchor}
        open={Boolean(userMenuAnchor)}
        onClose={handleUserMenuClose}
        onClick={handleUserMenuClose}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>

      {/* Mobile Menu */}
      <Menu
        anchorEl={mobileMenuAnchor}
        open={Boolean(mobileMenuAnchor)}
        onClose={handleMobileMenuClose}
        onClick={handleMobileMenuClose}
      >
        <MenuItem>
          <ListItemIcon>
            <Avatar
              sx={{
                width: 24,
                height: 24,
                backgroundColor: config.primaryColor || theme.palette.primary.main,
                fontSize: '0.75rem'
              }}
            >
              {userInfo.userFirstName?.charAt(0) || 'U'}
            </Avatar>
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body2">{userInfo.userFirstName}</Typography>
          </ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>

      {/* Quick Action Menu */}
      <Menu
        anchorEl={quickActionMenuAnchor}
        open={Boolean(quickActionMenuAnchor)}
        onClose={handleQuickActionMenuClose}
        onClick={handleQuickActionMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        {quickActions.map(({ to, label, icon: Icon }) => (
          <MenuItem key={to} onClick={() => navigate(to)}>
            <ListItemIcon>
              <Icon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Add {label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>

      {/* Desktop Navigation Drawer */}
      {!isMobile && (
        <Box
          component="nav"
          sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
        >
          <Drawer
            variant="permanent"
            open={true}
            sx={{
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: drawerWidth,
                borderRight: 1,
                borderColor: 'divider',
                backgroundColor: theme.palette.background.default
              }
            }}
          >
            <Toolbar /> {/* Spacer for AppBar */}
            <SidebarContent />
          </Drawer>
        </Box>
      )}

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: isMobile ? '100%' : { md: `calc(100% - ${drawerWidth}px)` },
          backgroundColor: theme.palette.background.default,
          minHeight: '100vh',
          pb: isMobile ? 7 : 0 // Add padding bottom for mobile bottom nav
        }}
      >
        <Toolbar /> {/* Spacer for AppBar */}
        <Box sx={{ p: 3 }}>
          <Outlet />
        </Box>
      </Box>

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <>
          {/* Floating Action Button for Quick Actions */}
          <Fab
            color="primary"
            aria-label="add"
            onClick={handleQuickActionMenuOpen}
            sx={{
              position: 'fixed',
              bottom: 15,
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: theme.zIndex.drawer + 2,
              backgroundColor: config.primaryColor || theme.palette.primary.main,
              '&:hover': {
                backgroundColor: config.primaryColor 
                  ? `${config.primaryColor}dd` 
                  : theme.palette.primary.dark
              }
            }}
          >
            <Add />
          </Fab>

          <Paper
            sx={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: theme.zIndex.drawer + 1,
              borderTop: 1,
              borderColor: 'divider'
            }}
            elevation={3}
          >
            <BottomNavigation
              value={bottomNavValue}
              onChange={handleBottomNavChange}
              sx={{
                backgroundColor: theme.palette.background.paper,
                '& .MuiBottomNavigationAction-root': {
                  color: theme.palette.text.secondary,
                  '&.Mui-selected': {
                    color: config.primaryColor || theme.palette.primary.main
                  }
                }
              }}
            >
              {/* First two items: Dashboard, Contacts */}
              {navItems.slice(0, 2).map(({ icon: Icon, label }, index) => (
                <BottomNavigationAction
                  key={index}
                  label={label}
                  icon={<Icon />}
                  sx={{
                    minWidth: 0,
                    '& .MuiBottomNavigationAction-label': {
                      fontSize: '0.75rem'
                    }
                  }}
                />
              ))}
              
              {/* Empty space for FAB */}
              <Box sx={{ width: 56, minWidth: 56 }} />
              
              {/* Next two items: Listings, OFI (excluding Actions) */}
              {navItems.slice(2, 4).map(({ icon: Icon, label }, index) => (
                <BottomNavigationAction
                  key={index + 2}
                  label={label}
                  icon={<Icon />}
                  sx={{
                    minWidth: 0,
                    '& .MuiBottomNavigationAction-label': {
                      fontSize: '0.75rem'
                    }
                  }}
                />
              ))}
            </BottomNavigation>
          </Paper>
        </>
      )}
    </Box>
  );
};

export default Layout;